import { useContext } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { LoginContext } from 'components/login/loginContext'
import { CartContext } from 'components/booking/context/cartContext'
import BookingCountdownTooltip from 'components/booking/countdown/bookingCountdownTooltip'
import useIsScrolled from 'components/common/useIsScrolled'
import { folioHasCampsites } from 'components/booking/context/bookingUtils'
import Logo from 'svgs/SnowPeakLogo.svg'
import AccountIcon from 'svgs/AccountIcon.svg'
import CartIcon from 'svgs/CartIcon.svg'
import { OuterContainer, InnerContainer, SubmenuContainer, MenuButton, IconContainer, AccountLink, CartLink, Arrow, BookButton } from './desktopMenu_styles'

const DesktopMenu = () => {
  const { prismicMainMenu: { data } } = useStaticQuery(query)
  const { userDetails } = useContext(LoginContext)
  const { cart, cartFolio } = useContext(CartContext)
  const isScrolled = useIsScrolled()

  const reservationCount = cart?.itemCount ?? 0
  const cartDestination = folioHasCampsites(cartFolio) ? '/booking' : '/booking/ofuro'

  return (
    <OuterContainer isScrolled={isScrolled}>
      <InnerContainer isScrolled={isScrolled}>
        <Link to='/' aria-label='home'>
          <Logo fill={isScrolled ? '#171717' : 'white'} />
        </Link>
        <ul>
          {data.body.map(menu =>
            <li key={menu.id}>
              {menu.primary.primary_nav_link ?
                <Link to={`/${menu.primary.primary_nav_link}`}>
                  {menu.primary.primary_nav_label}
                </Link>
                :
                <MenuButton onClick={() => document.activeElement.blur()} aria-label={`${menu.primary.primary_nav_label} dropdown`}>
                  {menu.primary.primary_nav_label}
                  <Arrow>▾</Arrow>
                </MenuButton>
              }
              <SubmenuGroup data={menu.items} />
            </li>
          )}
        </ul>
        <IconContainer>
          <AccountLink to='/account' $isScrolled={isScrolled} aria-label='account'>
            <p>{userDetails?.first_name}</p>
            <AccountIcon fill={isScrolled ? '#171717' : 'white'} />
          </AccountLink>
          <SubmenuGroup data={[ { sub_nav_link: 'poo', sub_nav_label: 'poo' }]} />
          {reservationCount > 0 &&
            <CartLink to={cartDestination} $isScrolled={isScrolled}>
              <CartIcon fill={isScrolled ? '#171717' : 'white'} />
              {`(${reservationCount})`}
              <BookingCountdownTooltip />
            </CartLink>
          }
        </IconContainer>
        <BookButton link='/booking' $isScrolled={isScrolled}>BOOK NOW</BookButton>
      </InnerContainer>
    </OuterContainer>
  )
}

export default DesktopMenu

const SubmenuGroup = ({ data }) => {
  if (data.length === 0) { return null }

  return (
    <SubmenuContainer>
      <ul>
        {data.map(submenu =>
          <li key={submenu.sub_nav_link}>
            {submenu.sub_nav_link ?
              <Link to={`/${submenu.sub_nav_link}`}>
                {submenu.sub_nav_label}
              </Link>
              :
              <p>
                {submenu.sub_nav_label}
              </p>
            }
          </li>
        )}
      </ul>
    </SubmenuContainer>
  )
}

export const query = graphql`
  query {
    prismicMainMenu {
      data {
        body {
          ... on PrismicMainMenuDataBodyPrimaryAndSubNavItem {
            id
            items {
              sub_nav_label
              sub_nav_link
            }
            primary {
              primary_nav_label
              primary_nav_link
            }
          }
        }
      }
    }
  }
`
